export const shortcutTypes = {
    expandAllEvents: 'expand-all-events',
    closeAllEvents: 'close-all-events',
    expandEvent: 'expand-event',
    closeEvent: 'close-event',
    scrollToEvent: 'scroll-to-event',
};
export const descriptions = {
    [shortcutTypes.expandAllEvents]: 'Expand all timeline events',
    [shortcutTypes.closeAllEvents]: 'Close all timeline events',
    [shortcutTypes.expandEvent]: 'Expand hovered timeline event',
    [shortcutTypes.closeEvent]: 'Close hovered timeline event',
};
export default shortcutTypes;
